import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import KvkkService from "../../services/KvkkService";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { Skeleton } from "@progress/kendo-react-indicators";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
} from "@mui/material";
import { PDFViewer } from "@progress/kendo-react-pdf-viewer";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";

const KvkkApproval = ({ onSubmit, checkboxLabel, id }) => {
  const [loading, setLoading] = React.useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [hasRead, setHasRead] = useState(false);
  const [dataPdf, setDataPdf] = React.useState();
  const [dataText, setDataText] = React.useState();
  const matches = useMediaQuery("(max-width:600px)");

  const isMobile = React.useMemo(() => {
    if (typeof window === "undefined") return false;

    // User agent ile mobil cihaz tespiti
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = [
      "android",
      "webos",
      "iphone",
      "ipad",
      "ipod",
      "blackberry",
      "windows phone",
      "mobile",
    ];

    const isMobileUA = mobileKeywords.some((keyword) =>
      userAgent.includes(keyword)
    );

    // Touch desteği kontrolü
    const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // Ekran boyutu kontrolü (yedek)
    const isSmallScreen = window.innerWidth <= 800;

    // Mobil olarak kabul et eğer: UA mobil ise VEYA (touch var ve ekran küçük)
    return isMobileUA || (hasTouch && isSmallScreen);
  }, []);
  React.useEffect(() => {
    setLoading(true);
    KvkkService.getLastOne(id)
      .then((result) => {
        setDataPdf(result.data.find((d) => d.dokumaN_TIPI === "PDF"));
        setDataText(result.data.find((d) => d.dokumaN_TIPI === "TEXT"));
      })
      .finally(() => setLoading(false));
  }, [id]);
  const handleCheckboxChange = (e) => {
    if (!hasRead) {
      setShowModal(true);
      return;
    }
    setIsChecked(e.value);
    onSubmit(e.value);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const accept = () => {
    setShowModal(false);
    setHasRead(true);
  };
  return (
    <Grid2 container>
      <Grid2 size={12}>
        <Checkbox
          checked={isChecked}
          onChange={handleCheckboxChange}
          id={"kvkkOnay" + id}
        >
          <IconButton color="primary" onClick={() => setShowModal(true)}>
            <TextSnippetIcon />
          </IconButton>

          <label
            htmlFor={"kvkkOnay" + id}
            className={"k-checkbox-label"}
            style={{ display: "inline-block" }}
          >
            {checkboxLabel}
          </label>
        </Checkbox>
      </Grid2>

      {showModal && (
        <Dialog
          open={showModal}
          onClose={handleCloseModal}
          maxWidth={"lg"}
          fullScreen={matches}
        >
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setShowModal(false)}
            aria-label="close"
            sx={{
              position: "absolute",
              right: 8,
              top: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle sx={{ mt: 2 }}>
            {(dataPdf || dataText)?.basliK_TR}
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                backgroundColor: "#f9f9f9",
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                lineHeight: "1.6",
                fontSize: "14px",
              }}
            >
              {dataPdf && !isMobile ? (
                <PDFViewer tools={[]} data={dataPdf?.iceriK_TR} zoom={1} />
              ) : (
                <div
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {loading && (
                    <Skeleton shape="rectangle" style={{ width: "100%" }} />
                  )}
                  {dataText?.iceriK_TR && dataText?.iceriK_TR}
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} onClick={accept} themeColor="primary">
              Okudum, Anladım
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Grid2>
  );
};

export default KvkkApproval;
